// import Cropper from 'cropperjs';
import validations from './validate-upload-img';

// let image;
const cropper = [];
// const imageExit = [];

export default {
  getCropped(e, action, name, _program, _id) {
    e.preventDefault();

    if (!cropper[name]) {
      return new Promise((resolve, reject) => {
        const inputFile = document.getElementById(`${name}-input-upload`);
        const file = inputFile?.files?.[0];

        if (!file) {
          reject(new Error('No file selected'));
          return;
        }

        const validationsImg = validations.validateSize(file, 100);

        if (!validationsImg) {
          document.getElementById(`${name}-imageText-error`).style.display = 'block';

          window.dispatchEvent(
            new CustomEvent('loading', {
              detail: { loading: false },
              bubbles: true,
              composed: true
            })
          );

          reject(new Error('File too large'));
          return;
        }

        inputFile.setAttribute('validate-todo', 'true');

        //  FIX HEIC / HEIF
        let mime = file.type;

        if (!mime || mime === '') {
          const ext = file.name.split('.').pop().toLowerCase();
          if (ext === 'heic') mime = 'image/heic';
          if (ext === 'heif') mime = 'image/heif';
          if (ext === 'pdf') mime = 'application/pdf';
        }

        const fixedFile = new File([file], file.name, {
          type: mime || 'application/octet-stream'
        });

        const formData = new FormData();
        formData.append('file', fixedFile);

        fetch(`${action}/api/files/upload/${_program}/${_id}`, {
          method: 'POST',
          body: formData
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error ${response.status}`);
            }
            return response.json();
          })
          .then((resultData) => {
            if (resultData.success) {
              setTimeout(() => {
                const errorEl = document.getElementById(`${name}-imageText-error`);
                if (errorEl) errorEl.style.display = 'none';
              }, 100);

              resolve(resultData.data?.url);
            } else {
              reject(resultData);
            }
          })
          .catch((err) => {
            console.error('Upload error:', err);
            reject(err);
          });
      });
    }

    return '';
  }
};
